import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { I18NextService } from 'angular-i18next';
import { SelectOption } from 'src/app/forms/components/input-select';
import { integrationAppSelectOptions, LabelData } from '../../integration-apps.types';

@Component({
  selector: 'app-instance-provisioning-label-form',
  templateUrl: './instance-provisioning-label-form.component.html',
  standalone: false
})
export class InstanceProvisioningLabelFormComponent implements OnChanges {

  @Input() labelData?: LabelData;
  @Output() formDataChange = new EventEmitter<LabelData>();
  @Output() formValidityChange = new EventEmitter<boolean>();

  public labelForm: FormGroup;
  public uninstallOptions: SelectOption[] = [];
  public labelTypeOptions: SelectOption[] = [];
  public labelVisibilityOptions: SelectOption[] = [];

  constructor(
    private fb: FormBuilder,
    private i18Next: I18NextService
  ) {
    this.uninstallOptions = this.translateOptions(
      integrationAppSelectOptions.uninstall
    );
    this.labelTypeOptions = this.translateOptions(
      integrationAppSelectOptions.labelType
    );
    this.labelVisibilityOptions = this.translateOptions(
      integrationAppSelectOptions.labelVisibility
    );

    this.labelForm = this.fb.group({
      name: ['', Validators.required],
      key: ['', Validators.required],
      onUninstall: ['keep', Validators.required],
      labelType: ['generic', Validators.required],
      visible: ['visible', Validators.required]
    });
    
    this.labelForm.valueChanges.subscribe(() => {
      this.emitLabelData();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['labelData']) {
      this.setLabelData();
    }
  }

  private emitLabelData(): void {
    const formValues = this.labelForm.getRawValue();
    const labelData: LabelData = {
      type: 'label',
      ...formValues,
    }
    this.formValidityChange.emit(this.labelForm.valid);
    this.formDataChange.emit(labelData);
  }

  private setLabelData(): void {
    if (this.labelData) {
      this.labelForm.patchValue({
        name: this.labelData?.name,
        key: this.labelData?.key,
        onUninstall: this.labelData?.onUninstall,
        labelType: this.labelData?.labelType,
        visible: this.labelData?.visible
      }, { emitEvent: false });
    } else {
      this.labelForm.reset({
        name: '',
        key: '',
        onUninstall: 'keep',
        labelType: 'generic',
        visible: 'visible'
      }, { emitEvent: false });
    }
  }

  private translateOptions(
    options: readonly { labelKey: string; value: string }[]
  ): SelectOption[] {
    return options.map(option => ({
     label: this.i18Next.t(option.labelKey),
     value: option.value,
    }));
  }
}
